import api from "./api";
import store from '../store';
import { setUser } from "../actions";

let refreshTokenTimeout;

const refreshToken = () => {
  api.refreshToken()
    .then(res => {
      startRefreshTokenTimer(res.data)
      store.dispatch(setUser(res.data))
    })
}

export const startRefreshTokenTimer = (user) => {
  const jwtHeader = JSON.parse(atob(user.token.split('.')[1]))
  const expires = new Date(jwtHeader.exp * 1000)
  const timeout = expires.getTime() - Date.now() - (60 * 1000)
  stopRefreshTokenTimer()
  setTimeout(refreshToken, timeout);
}

const stopRefreshTokenTimer = () => {
  clearTimeout(refreshTokenTimeout)
}